module.exports = __webpack_public_path__ + "img/dashboardIcon1.ecbf733e.png";